/**
 * 锚点定位辅助
 * 页面正文由 JS 运行时渲染，浏览器处理 URL 里的 #hash 时目标元素还不存在，
 * 不会自动滚动，所以渲染完成后手动定位一次。
 * 页内已加载后再点同页锚点链接，浏览器原生行为即可，无需额外处理。
 */
export function scrollToHash(options = {}) {
  const behavior = options.behavior || 'auto';
  const raw = window.location.hash;
  if (!raw || raw.length < 2) return;

  let id = raw.slice(1);
  try {
    id = decodeURIComponent(id);
  } catch (err) {
    // hash 里有非法转义字符时退回原始字符串
  }

  const target = document.getElementById(id);
  if (!target) return;
  target.scrollIntoView({ behavior, block: 'start' });
}
